import "./Footer.css";

export default function Footer(){
  return (
    <footer className="footer bg-gray-800 text-white py-4">
      <div className="container mx-auto text-center">
        <p>&copy; Honest Option House Buyers. All rights reserved.</p>
      </div>
    </footer>
  );
};
